module.exports = __webpack_public_path__ + "img/application.64fc54b7.png";